import { MandatorFeatures, useMandatorContext } from "@bn/theming";

/**
 * Reads an opt-in feature flag off the current mandator's config. Features are
 * declared in `mandatorsConfig` so enabling one for another mandator is a
 * single config edit rather than a change at every call site.
 */
export const useMandatorFeature = (
  feature: keyof MandatorFeatures
): boolean => {
  const { config } = useMandatorContext();
  return Boolean(config?.features?.[feature]);
};
